<template>
  <div class="image-question">
    <div class="question-image mb-3" v-if="question.image_url">
      <img :src="AmazonAssetsUrl + 'profile-pictures/' + question.image_url" alt="Question image" class="img-fluid rounded" />
    </div>
    <div class="answers">
      <button
        v-for="([id, answer], arrayIndex) in Object.entries(question.options)"
        :key="id"
        class="answer-btn"
        @click="$emit('select-answer', id.toString())"
        :class="{ 'selected': selectedAnswer == id.toString() }"
      >
        <span class="option-letter">{{ ['A', 'B', 'C', 'D'][arrayIndex] }}</span>
        {{ answer }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  question: {
    type: Object,
    required: true
  },
  selectedAnswer: {
    type: [Number, null],
    default: null
  }
});
const emit = defineEmits(['select-answer']);

const AmazonAssetsUrl = import.meta.env.VITE_AMAZON_ASSETS_URL;
</script>